<template>
  <div
    class="custom-input-number"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
 >
    <el-input-number
      v-bind="$attrs"
      :controls="controls"
      controls-position="right"
      class="custom-input-number-input"
      :style="inputStyle"
   />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

defineOptions({ name: 'CustomInputNumber', inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    width?: string;
 }>(),
  { width: '80px' },
);

const controls = ref(false);

const inputStyle = computed(() => ({
  width: props.width,
}));

function handleMouseEnter() {
  controls.value = true;
}

function handleMouseLeave() {
  controls.value = false;
}
</script>

<style lang="scss" scoped>
.custom-input-number {
  width: fit-content;

  :deep(.el-input__inner) {
    text-align: left;
  }

  :deep(.el-input-number__decrease),
  :deep(.el-input-number__increase) {
    width: 23px;
  }
}
</style>
